import { useState } from "react";
import { v4 as uuid } from "uuid";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { inviteUserFromAdmin } from "../../../../../actions";
import { Button } from "../../../../../components/button/button";
import { InviteUserModalStyled } from "./invite-user-modal.styles";
import DialogComponent from "../../../../../components/dialog-component/dialog-component";
import TextInputFormField from "../../../../../components/form-fields/text-input-field/text-input-form-field";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { useAppDispatch } from "../../../../../store/hooks";
import { inviteUserFormValidation } from "../../../../../utils/validations";
import { yupResolver } from "@hookform/resolvers/yup";

const InviteUserModal = ({ onClose, fetchUserData }: any) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { handleSubmit, control } = useForm({
    mode: "all",
    resolver: yupResolver(inviteUserFormValidation()),
  });

  const handleOnSubmit = async (data: any) => {
    try {
      setIsLoading(true);
      const response = await inviteUserFromAdmin({
        name: data?.name,
        inviteEmail: data?.email,
      });
      const { message }: { message: string } = response?.data;
      onClose && onClose();
      dispatch(
        addNotification({
          id: uuid(),
          type: "success",
          message: message,
        })
      );
      await fetchUserData();
    } catch (error: any) {
      console.log({ error });

      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: error.response?.data?.message || error.message,
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogComponent
      open
      title="Invite User"
      onClose={onClose}
      content={
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <InviteUserModalStyled>
            <Box className="fields-wrapper">
              <TextInputFormField control={control} label="Name" name="name" placeholder="Enter your name" />
              <TextInputFormField
                control={control}
                label="Email"
                name="email"
                placeholder="Enter your email"
              />
            </Box>
            <Button type="submit" isLoading={isLoading}>
              Add user
            </Button>
          </InviteUserModalStyled>
        </form>
      }
    />
  );
};

export default InviteUserModal;
